import React from "react";
import PageLayout from "../components/PageLayout";
import PageHero from "../components/PageHero";
import FAQ from "../components/FAQ";

const FaqPage = () => (
    <PageLayout title="FAQ · IndoBlitz" testId="faq-page">
        <PageHero
            eyebrow="FAQ"
            title="Everything you"
            accent="want to know."
            intro="Pricing, delivery, the CSR structure, our rural-first model and how fast we can start - answered plainly."
            testId="faq-hero"
        />
        <FAQ />
    </PageLayout>
);

export default FaqPage;
